import { createSelector } from 'reselect';
import { KEY } from './';
import { GlobalState } from 'store/types';

const getKiosksState = (state: GlobalState) => state[KEY];

const selectKiosks = createSelector(getKiosksState, (kiosks) => kiosks.kiosks);

const selectKiosk = createSelector(getKiosksState, (kiosks) => kiosks.kiosk);

const selectKioskSchedule = createSelector(getKiosksState, (state) => state.kioskSchedule);

const selectAppVersion = createSelector(getKiosksState, (state) => state.version);

const selectAction = createSelector(getKiosksState, (state) => state.action);

const selectKioskLoginToken = createSelector(getKiosksState, (state) => state.loginToken);

const selectAutoRefresh = createSelector(getKiosksState, (state) => state.autoRefresh);

const selectMessage = createSelector(getKiosksState, (state) => state.action.message);

const selectExportData = createSelector(getKiosksState, (state) => state.export.data);

const selectExportPending = createSelector(getKiosksState, (state) => state.export.pending);

export const selectors = {
  selectKiosks,
  selectMessage,
  selectKiosk,
  selectKioskSchedule,
  selectAppVersion,
  selectAction,
  selectKioskLoginToken,
  selectAutoRefresh,
  selectExportData,
  selectExportPending
};
